import MenuItemAssortment from './MenuItemAssortment'

export default MenuItemAssortment
